import axios from 'axios';

/**
 * Base API service for making HTTP requests
 * Configures axios with common settings for all requests
 */

const baseURL = '/api';

// Create an axios instance with custom config
const api = axios.create({
  baseURL,
  headers: {
    'Content-Type': 'application/json'
  }
});

// Note: We don't need to add X-API-Token handling here as it's already in axiosSetup.js
// which applies to all axios instances globally.

// Request interceptor for adding auth token
api.interceptors.request.use(
  config => {
    // Get token from localStorage if it exists
    const token = localStorage.getItem('token');
    
    // If token exists, add to headers
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    
    return config;
  },
  error => Promise.reject(error)
);

export default api; 